<template>
    <div class="widget-inner mt-5 xcrossSeller" v-if="found">
        <div class="headline">
            {{ $translate("Servershop5::Template.zubehoerundersatz") }}
        </div>
        <div class="sub-headline mb-4">
            {{ $translate("Servershop5::Template.zubehoerundersatz") }}
        </div>
        <div class="hide-more-items" ref="hidding" id="hidden_crossmore">
            <template v-if="Object.keys(alldata).length > 0">
                <ul class="product-list row grid categoryItem">
                    <template v-for="group in alldata">
                        <template v-for="item in group">
                            <li class="col-12 col-sm-6 col-md-4 col-lg-3">
                                <category-item
                                        :item-data="item.data"
                                        :decimal-count="2">
                                </category-item>
                            </li>
                        </template>
                    </template>
                </ul>
            </template>
            <template v-else>
                <div class="d-flex justify-content-center h-100 align-items-center">
                    <div class="spinner-border text-primary large-spinner" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </template>
        </div>
        <button class="showMore btn btn-dark-blue mx-auto d-flex mt-3">
            <span>
                 {{ $translate("Servershop5::Template.zuebhoerMore") }}
            </span>
            <span>
                {{ $translate("Servershop5::Template.zubehoerLess") }}
            </span>
        </button>
    </div>
</template>
<script>
    export default
    {
        props: ['template','item'],
        data: function()
        {
            return {
                itemdata:this.item,
                alldata:{},
                open:false,
                found:false
            };
        },
        mounted: function()
        {
            this.getcrossItems();
            vueEventHub.$on("xcrossSeller", data =>
            {
              this.open = data
            });
        },
        methods:
        {
            getcrossItems: function ()
            {
                let _self = this;
                var MainItem = this.itemdata;
                if(MainItem.hasOwnProperty('variationProperties'))
                {
                    for (var i = 0; i < MainItem.variationProperties.length; i++)
                    {
                        if (MainItem.variationProperties[i].id === 5)
                        {
                            for (var a = 0; a < MainItem.variationProperties[i].properties.length; a++) {
                                if (MainItem.variationProperties[i].properties[a].id === 10)
                                {
                                    _self.found = true;
                                    $.ajax({
                                        type: 'GET',
                                        url: '/'+App.language+'/crossseller/findall/'+MainItem.variationProperties[i].properties[a].values.value+'/'+App.language+'/',
                                        success: function (data)
                                        {
                                            _self.alldata = data;
                                            _self.$store.commit("setXCrossSeller", data);
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            console.log(jqXHR);
                                        }
                                    })

                                }
                            }
                        }
                    }
                }
            }
        },
        computed:
        {
            crossitems:function()
            {
                return this.items;
            }
        }
    }
</script>
